import { create } from "zustand"
import { persist } from "zustand/middleware"

export type ChatPanelMode = "closed" | "docked" | "floating"

interface LayoutState {
  isSidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  chatPanelMode: ChatPanelMode
  openChatPanel: () => void
  closeChatPanel: () => void
  setChatPanelMode: (mode: ChatPanelMode) => void
}

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      isSidebarOpen: true,
      setSidebarOpen: (open) => set({ isSidebarOpen: open }),
      toggleSidebar: () =>
        set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      chatPanelMode: "closed",
      openChatPanel: () => set({ chatPanelMode: "docked" }),
      closeChatPanel: () => set({ chatPanelMode: "closed" }),
      setChatPanelMode: (mode) => set({ chatPanelMode: mode }),
    }),
    {
      name: "layout-storage",
    },
  ),
)
